export const promotionInfo = {
	title: "Datos de la promoción",
	description:
		"Defina todos los parámetros necesarios para crear una promoción especializada para sus clientes.",
	promotionName: {
		label: "Nombre de la promoción",
		placeholder: "Ingrese el nombre de la promoción",
	},
	promotionDescription: {
		label: "Descripción de la promoción",
		placeholder: "Ingrese la descripción de la promoción",
	},
	expiration: {
		label: "Expiración",
		info:
			"La promoción será válida hasta la fecha seleccionada. Cuando llegue la fecha de expiración, la promoción quedará inactiva y usted podrá cambiar la fecha de expiración.",
		notExpire: "No expira",
	},
	automaticMessage: {
		label: "Mensajes automáticos para clientes",
		info:
			"Todos los clientes que ganen la promoción reciben mensajes automáticos a través del canal seleccionado. Estos envíos tienen costo",
		sendMessage: "Enviar mensajes automáticos",
	},
	whatsUp: {
		label: "Mostrar promociones en '¿Qué hay de bueno?'",
		info: "Todas las promociones habilitadas serán mostradas en '¿Qué hay de bueno?'.",
		showPromotions: "Mostrar promociones en '¿Qué hay de bueno?'",
	},
	places: "Locales de la promoción",
	errors: {
		requiredField: "Este campo es obligatorio",
		dateFormat: "Formato de fecha inválido",
		dayDiff: "Necesario al menos un día de diferencia",
		selectPlace: "Seleccione al menos un local",
		maxUses:
			"Valor no puede ser superior a la cantidad de productos definida en el paso anterior",
	},
};
